// src/components/about_us/AboutContent.jsx
import React from "react";
import RichTextRenderer from "../common/RichTextRenderer";

const AboutContent = ({ title, content, pdfCover, pdfFile }) => {
  if (!content && !pdfCover && !pdfFile) {
    return null;
  }

  return (
    <section className="w-full section-surface-mist py-16 sm:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-14 items-start">
          {/* Left: editorial column */}
          <div className="max-w-3xl pl-5 sm:pl-7 md:pl-8 border-l-4 border-lake-300 text-brand-foreground animate-slide-in-left">
            {title && (
              <div className="mb-5 pb-4 border-b border-mist-100">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-brand-foreground text-pretty">
                  {title}
                </h2>
              </div>
            )}
            {content && (
              <RichTextRenderer
                content={content}
                className="max-w-none space-y-6"
                textColorClass="text-gray-700"
                linkColorClass="text-mist-500 underline hover:text-lake-500"
                bodyTextClass="text-lg lg:text-xl leading-loose"
                captionTextClass="text-base lg:text-lg"
                compactHeadings
              />
            )}
          </div>

          {/* Right: PDF cover ??fade in from right toward left */}
          <div className="flex justify-center animate-fade-in-from-right">
            {pdfCover?.url && pdfFile?.url ? (
              <a
                href={pdfFile.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative transition-transform hover:scale-105"
              >
                <img
                  src={pdfCover.url}
                  alt="PDF Catalog Cover"
                  className="shadow-2xl rounded-lg border border-mist-200"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg">
                  <span className="bg-white px-4 py-2 rounded shadow text-base font-semibold text-slate-800">
                    Click to View PDF
                  </span>
                </div>
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutContent;
